var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.858 18.4287C16.3366 18.4287 17.5366 17.2287 17.5366 15.7501C17.5366 14.2716 16.3366 13.0716 14.858 13.0716C13.3794 13.0716 12.1794 14.2716 12.1794 15.7501C12.1794 17.2287 13.3794 18.4287 14.858 18.4287ZM11.2866 9.50014H32.7152C33.7009 9.50014 34.5009 10.3001 34.5009 11.2859V26.2216L28.7812 21.343C27.0134 19.8394 24.2473 19.8394 22.4955 21.3323L9.50087 32.1751V11.2859C9.50087 10.3001 10.3009 9.50014 11.2866 9.50014ZM32.7152 5.92871H11.2866C8.33301 5.92871 5.92944 8.33228 5.92944 11.2859V32.7144C5.92944 35.668 8.33301 38.0716 11.2866 38.0716H32.7152C35.6687 38.0716 38.0723 35.668 38.0723 32.7144V11.2859C38.0723 8.33228 35.6687 5.92871 32.7152 5.92871Z",
    fill: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_16587",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 34,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.858 18.4287C16.3366 18.4287 17.5366 17.2287 17.5366 15.7501C17.5366 14.2716 16.3366 13.0716 14.858 13.0716C13.3794 13.0716 12.1794 14.2716 12.1794 15.7501C12.1794 17.2287 13.3794 18.4287 14.858 18.4287ZM11.2866 9.50014H32.7152C33.7009 9.50014 34.5009 10.3001 34.5009 11.2859V26.2216L28.7812 21.343C27.0134 19.8394 24.2473 19.8394 22.4955 21.3323L9.50087 32.1751V11.2859C9.50087 10.3001 10.3009 9.50014 11.2866 9.50014ZM32.7152 5.92871H11.2866C8.33301 5.92871 5.92944 8.33228 5.92944 11.2859V32.7144C5.92944 35.668 8.33301 38.0716 11.2866 38.0716H32.7152C35.6687 38.0716 38.0723 35.668 38.0723 32.7144V11.2859C38.0723 8.33228 35.6687 5.92871 32.7152 5.92871Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_16587)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatar);
export default __webpack_public_path__ + "static/media/NoAvatar.c7f48b2e2d12c813c047e0afb8af5e67.svg";
export { ForwardRef as ReactComponent };